/** Tema do app: claro é o padrão; escuro é escolha do usuário, guardada no aparelho. */
export type Tema = "claro" | "escuro";

const CHAVE = "vetbolso.tema";

export function temaAtual(): Tema {
  return document.documentElement.dataset.theme === "dark" ? "escuro" : "claro";
}

export function aplicarTema(t: Tema) {
  const raiz = document.documentElement;
  if (t === "escuro") raiz.dataset.theme = "dark";
  else delete raiz.dataset.theme;
  try {
    localStorage.setItem(CHAVE, JSON.stringify(t));
  } catch {
    /* sem armazenamento: vale só nesta sessão */
  }
  // A barra do sistema acompanha o cabeçalho (--surface do tema em uso).
  const cor = getComputedStyle(raiz).getPropertyValue("--surface").trim();
  document.querySelector('meta[name="theme-color"]')?.setAttribute("content", cor);
}
